<div *ngIf="!isUserLoggedIn && tenantService.tenantIdentifier!= null" class="login-container">
  <div class="container vertical-center">
    <div class="row justify-content-center w-100">
      <div class="col-xl-5 col-lg-6 col-md-7 col-sm-10 col-10">
        <div id="logo" class="nice-esp-logo" role="img" [attr.aria-label]="'login.logo' | translate">
        </div>
        <div class="card rounded-0">
          <div class="card-body wfm-login-title">
            <h1 id="signin-heading" class="sign-in-text card-title">{{"login.signin" | translate}}</h1>
          </div>
          <div class="card-body">
            <form [formGroup]="loginForm" novalidate (submit)="logUserIn()" aria-labelledby="signin-heading">
              <div class="form-group">
                <div class="input-group wfm-input-group input-group-username">
                  <input #usernameInput [(ngModel)]="txtUsername" (ngModelChange)="txtUsernameChanged($event)" type="text" class="form-control wfm-form-control" formControlName="username" id="username"
                         autocomplete="off" placeholder="{{'login.username' | translate}}" minlength="1" maxlength="75"
                         [attr.disabled]="isLoadingFlag || isLoadingLanguage? '' : null" [ngClass]="showErrorUsername ? 'input-txt-error' : ''"
                         [attr.aria-invalid]="formControlIsInvalid('username')"
                         aria-describedby="errorUsername"
                         required aria-required="true"
                         autofocus>
                  <label for="username" class="screenreader-only" [ngClass]="usernameCssValidationObject">{{'login.username' | translate}}
                    <span
                      class="required-asterisk" aria-hidden="true">*</span>
                  </label>
                  <div id="errorUsername" class="invalid-feedback" wfm-error-message-username
                       role="alert">
                    <ng-container *ngIf="showErrorUsername && getFormControlErrors('username') !== null">
                      <ng-container *ngTemplateOutlet="errorMessages; context: {$implicit: getFormControlErrors('username')}">
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group wfm-input-group input-group-password">
                  <input [(ngModel)]="txtPassword" (ngModelChange)="txtPasswordChanged($event)" [attr.type]="showPassword ? 'text': 'password'"
                         class="form-control wfm-form-control wfm-input-with-icon" formControlName="password"
                         id="password" autocomplete="off" #inputPassword placeholder="{{'login.password' | translate}}" minlength="1"
                         [attr.disabled]="isLoadingFlag || isLoadingLanguage? '' : null" [ngClass]="showErrorPassword ? 'input-txt-error' : ''"
                         [attr.aria-invalid]="formControlIsInvalid('password')"
                         aria-describedby="errorPassword"
                         required aria-required="true"
                         maxlength="256">
                  <label for="password" class="screenreader-only" [ngClass]="passwordCssValidationObject">{{'login.password' | translate}}
                     <span
                      class="required-asterisk" aria-hidden="true">*</span>
                  </label>
                  <div class="input-group-append wfm-input-password-icon">
                    <button type="button" class="input-group-text" wfm-input-password-icon (click)="togglePasswordIcon()"
                         [attr.aria-label]="(showPassword ? 'login.password.hide' : 'login.password.show') | translate"
                         [attr.aria-pressed]="showPassword"
                         [ngClass]="passwordCssValidationObject">
                      <svg wfm-input-pwd-show xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20"
                           *ngIf="!showPassword">
                        <title>{{'login.password.show' | translate}}</title>
                        <path d="M10 3C5 3 0 8.4 0 10.2 0 11.7 4.6 17 10 17s10-5.7 10-6.8C20 9 15.2 3 10 3zm0 12.3c-4.1 0-7.7-3.9-8.3-5.1.5-1.4 4.4-5.5 8.3-5.5 3.8 0 7.4 4 8.2 5.4-.8 1.4-4.3 5.2-8.2 5.2zm-.1-9.2c-2 0-3.6 1.7-3.6 3.7s1.6 3.7 3.6 3.7 3.6-1.7 3.6-3.7-1.7-3.7-3.6-3.7zm0 5.9c-1.2 0-2.1-1-2.1-2.2s1-2.2 2.1-2.2c1.2 0 2.1 1 2.1 2.2S11 12 9.9 12zm0-3.4c-.7 0-1.2.6-1.2 1.2 0 .7.5 1.2 1.2 1.2s1.2-.6 1.2-1.2c0-.7-.6-1.2-1.2-1.2z" id="svg_1" class="selected" fill="#6d6d6d" fill-opacity="1"/>
                      </svg>
                      <svg wfm-input-pwd-hide xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" *ngIf="showPassword">
                        <title>{{'login.password.hide' | translate}}</title>
                        <path d="M19.8,7.2C20.1,6.8,20,6.3,19.7,6c-0.4-0.3-0.9-0.2-1.2,0.1c0,0-3.2,3.9-8.5,3.9S1.5,6.2,1.5,6.1C1.2,5.8,0.7,5.7,0.3,6 C0,6.3-0.1,6.8,0.2,7.2c0.1,0.1,0.5,0.6,1.4,1.4l-1.5,1.8l1.3,1.1l1.5-1.8c0.6,0.4,1.4,0.8,2.2,1.2L4.3,13l1.6,0.6l0.8-2.4 c0.8,0.2,1.6,0.3,2.5,0.4v2.5h1.7v-2.5c0.9-0.1,1.8-0.2,2.5-0.4l0.9,2.4l1.6-0.6l-0.8-2.3c0.8-0.3,1.5-0.7,2.1-1.1l1.5,1.9l1.3-1 l-1.5-1.8C19.3,7.9,19.8,7.3,19.8,7.2z" id="svg_1" class="selected" fill="#6d6d6d" fill-opacity="1"/>
                      </svg>
                    </button>
                  </div>
                  <div id="errorPassword" class="invalid-feedback" wfm-error-message-password
                       role="alert">
                    <ng-container *ngIf="showErrorPassword && getFormControlErrors('password') !== null">
                      <ng-container *ngTemplateOutlet="errorMessages; context: {$implicit: getFormControlErrors('password')}">
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="text-danger form-group" data-t="loginFailedMessage" role="alert">
                <ng-container *ngIf="showInvalidLoginMessage | async">{{loginErrorMessage}}</ng-container>
              </div>
              <div class="form-group language">
                <div class="input-group wfm-input-group">
                    <label for="localeCombo-label">{{'login.language' | translate}}</label>
                </div>
                <div class="form-group">
                  <wfm-select #localeCombo selectName="localeCombo" selectId="localeCombo"
                    [items]="localeComboList" [attr.disabled]="!isLoadingFlag || isLoadingLanguage? null : ''"
                    (wfmSelectEvent)="updateLocaleCombo($event)" [selectedItem]="localeComboSelected">
                  </wfm-select>
                </div>
              </div>
              <button type="submit" id="btnLogin" class="btn btn-primary btn-lg btn-block"
                      [attr.disabled]="isLoadingFlag || isLoadingLanguage ? true : null">
                  {{"login.signin" | translate}}
              </button>
            </form>
            <ng-template #errorMessages let-errors>
              <ng-container *ngIf="errors.required">{{"login.error.required" | translate}}<br/></ng-container>
              <ng-container *ngIf="errors.minlength">
                  {{"login.error.minlengthBefore" | translate}} {{errors.minlength.requiredLength}} {{"login.error.minlengthAfter" | translate}}<br/>
              </ng-container>
              <ng-container *ngIf="errors.maxlength">
                  {{"login.error.maxlengthBefore" | translate}} {{errors.maxlength.requiredLength}} {{"login.error.maxlengthAfter" | translate}}<br/>
              </ng-container>
              <ng-container *ngIf="errors.pattern">
                  {{"login.error.pattern" | translate}}
              </ng-container>
            </ng-template>
            <wfm-plan-loading-overlay *ngIf="isLoadingFlag || isLoadingLanguage"></wfm-plan-loading-overlay>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer *ngIf="!isUserLoggedIn" class="row copyRight-contactUs" id="copyRight-contactUs">
    <span id="copyrightMessage">{{copyrightMessage}}</span>
  </footer>
</div>
<div class="login-loading-content" *ngIf="isUserLoggedIn">
  <div *ngIf="isLoadingFlag">
    <wfm-plan-loading-overlay></wfm-plan-loading-overlay>
    <div class="page-header">
      <wfm-page-title title="{{'login.page.loading' | translate}}"></wfm-page-title>
    </div>
    <p>{{'login.page.loading.details' | translate}}</p>
  </div>
  <div *ngIf="!isLoadingFlag">
    <div class="page-header">
      <wfm-page-title title="{{'login.page.loading.error' | translate}}"></wfm-page-title>
    </div>
    <p>{{'login.page.loading.error.details' | translate}}</p>
    <breeze-button buttonText="{{'login.page.loading.retry'|translate}}"
                        [isPrimary]="true"
                        (clicked)="authorizeUser()"></breeze-button>
</div>
</div>